import React from "react";
import {
    Box,
    Grid,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Button,
    DialogActions
} from "@mui/material";
import { Chip, Table, Tooltip } from "@mui/joy";
import { useUser } from "../../config/UserContext";
import { CoursePdfReport } from "../ReportGenerationComponents/CoursePdfReport";
import { BsFiletypePdf } from "react-icons/bs";


export default function CourseRegistrationHistory({ open, onClose, courseDataFromParent = {} }) {

    const { userData, roleDetail, homeDetail, trainingProviders } = useUser();
    const [courseBadgeTableData, setCourseBadgeTableData] = React.useState([]);
    const [courseData, setCourseData] = React.useState({});
    

    React.useEffect(() => {
        setCourseData(courseDataFromParent.parent || {});
        setCourseBadgeTableData(courseDataFromParent.history || []);
    }, [courseDataFromParent?.parent, courseDataFromParent?.history]);

    


    const handleDownloadPDF = async () => {
        let userDetails = userData;
        userDetails["homeName"] = homeDetail.homeName;
        userDetails["roleName"] = roleDetail.roleName;
        
        await CoursePdfReport(userDetails, courseBadgeTableData, trainingProviders, 'Course History', 'Carepassport_CourseHistory_' + courseData.crsId + "_" + userDetails?.user_id, false, 2);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="lg"
                fullWidth
                disableScrollLock={true}
                PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
            >
                <DialogTitle variant="body1">Course History</DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <Typography variant="h6" gutterBottom>
                            </Typography>

                            <Box sx={{ mt: 2 }}>
                                {[
                                    { label: "Title", value: courseData.title },
                                    { label: "Description", value: courseData.description },
                                    { label: "User ID", value: userData?.user_id },
                                    { label: "Home ", value: homeDetail?.homeName },
                                    { label: "Role ", value: roleDetail?.roleName },

                                ].map((field, index) => (
                                    <Box
                                        key={field.label}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'start',
                                            mb: 2,
                                            "&:last-child": { mb: 0 }
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            color="primary"
                                            sx={{
                                                minWidth: '120px',
                                                pt: 0.5
                                            }}
                                        >
                                            {field.label}:
                                        </Typography>
                                        <Typography variant="body2">
                                            {field.value || "N/A"}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>

                        </Grid>

                        <Grid item xs={12} md={8}>

                            <Typography variant="h6">
                                History
                                {courseBadgeTableData.length > 0 && (
                                    <Tooltip title="Download Course History as PDF" >
                                        <IconButton
                                            color="primary"
                                            variant="outlined"
                                            onClick={handleDownloadPDF}
                                            title="Download Course History"
                                        >
                                            <BsFiletypePdf />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Typography>
                            <Box sx={{ mt: 2 }}>

                                <Table
                                    borderAxis="bothBetween"
                                    stripe="odd"
                                    hoverRow
                                    sx={{ minWidth: 700 }}
                                >
                                    <thead>
                                        <tr>
                                            <th>Course Code</th>
                                            <th>Version</th>
                                            <th>Training Provider</th>
                                            <th>Date</th>
                                            <th>Expiry Date</th>
                                            <th>Status</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(courseBadgeTableData.length > 0) ?
                                            courseBadgeTableData.map((row) => (
                                                <tr key={row._id}>
                                                    <td>{row.course_id}</td>
                                                    <td>{row.courseVersion.tp_course_code}</td>
                                                    <td>{trainingProviders[parseInt(row.courseVersion.training_provider_id)]}</td>
                                                    <td>
                                                        {new Date(row.completion_date).toLocaleDateString()}
                                                    </td>
                                                    <td>
                                                        {(row.expiry_date != "") ? new Date(row.expiry_date).toLocaleDateString() : "N/A"}
                                                    </td>
                                                    <td>
                                                        <Chip
                                                            color={row.verification === "Validated" ? "success" : (row.verification === "Expired") ? "danger" : "warning"}
                                                            variant="soft"
                                                            size="sm"
                                                        >
                                                            {row.verification}
                                                        </Chip>
                                                    </td>

                                                </tr>
                                            ))
                                            : <td colSpan={5} style={{ "textAlign": "center" }}>No history available</td>
                                        }
                                    </tbody>
                                </Table>
                            </Box>

                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Close</Button>
                </DialogActions>
            </Dialog>

        </>
    );
}
